import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import BridgecrewConfigListing from './BridgecrewConfigListing'
import BridgecrewCredentialsForm from './BridgecrewCredentialsForm'

export default function BridgecrewPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={BridgecrewCredentialsForm}
            PullConfigListingView={BridgecrewConfigListing}
        />
    )
}